<template>
  <div>
    <notifications></notifications>
    <router-view></router-view>
  </div>
</template>

<script >
export default {
  data() {
    return {
      color: 'rgba(76, 114, 109, 0.15)'
    }
  },
  created() {
    if (process.env.VUE_APP_STYLE === 'ederit') {
      this.color = 'rgba(255, 165, 52, 0.1)';
    } else if (process.env.VUE_APP_STYLE === 'ocb') {
      this.color = 'rgb(38,61,136, 0.1)';
    } else if (process.env.VUE_APP_STYLE === 'eterno') {
      this.color = 'rgba(13, 10, 7, 0.1)';
    }  else if (process.env.VUE_APP_STYLE === 'drmatiasek') {
      this.color = '#c7f2ff';
    }  else if (process.env.VUE_APP_STYLE === 'elbpneumologie') {
      this.color = '#EBF3F8';
    } 
    else if (process.env.VUE_APP_STYLE === 'yuvell') {
      this.color = '#F8ECEC';
    } 
    else if (process.env.VUE_APP_STYLE === 'wah') {
      this.color = 'rgba(246, 238, 223, 0.1)';
    }
    else if (process.env.VUE_APP_STYLE === 'ahz') {
      this.color = '#C1DEED';
    }
    else if (process.env.VUE_APP_STYLE === 'assmann') {
      this.color = '#f2a0ae';
    }
    else {
      this.color = 'rgba(13, 10, 7, 0.1)';
    }

  }
}
</script>

<style>
.table-striped tbody tr:nth-of-type(odd) {
  background: v-bind(color);
}
</style>


<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
